<template>
  <v-card class="pa-8">
    <v-overlay v-model="settingFilters">
      <v-progress-circular indeterminate size="32" />
    </v-overlay>
    <v-card-title
      v-if="areSettingsEmpty"
      class="error--text d-flex flex-column justify-center align-center"
    >
      <v-icon color="error">mdi-alert</v-icon>
      <span>Você não selecionou nenhum item nas configurações</span>
      <p class="primary--text">
        Clique no botão <v-icon>mdi-cog</v-icon> para configurar os filtros
      </p>
    </v-card-title>
    <validation-observer v-else-if="!settingFilters" v-slot="{ invalid }">
      <v-card-subtitle class="error--text"
        >Todos os campos abaixo são obrigatórios</v-card-subtitle
      >
      <v-card-text>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Gate"
          v-if="!empresaAtual.gate"
        >
          <template #items>
            <v-col>
              <validation-provider
                name="gate"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="params.gate.value"
                  label="Gate"
                  prepend-icon="mdi-domain"
                  :items="gates"
                  :item-text="(item) => `${item.business_name} - ${item.cnpj}`"
                  item-value="public_id"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data Do Agendamento"
          v-if="showDataAgendamento"
        >
          <template #items>
            <v-col v-if="params.data_agendamento_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_agendamento_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_agendamento_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_agendamento_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data Da Triagem"
          v-if="showDataTriagem"
        >
          <template #items>
            <v-col v-if="params.data_triagem_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_triagem_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_triagem_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_triagem_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data Da Cota"
          v-if="showDataCota"
        >
          <template #items>
            <v-col v-if="params.data_cota_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_cota_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_cota_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_cota_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Embalagem"
          v-if="showEmbalagem"
        >
          <template #items>
            <relatorio-carga-descarga-list-filtro-modal-item-input-embalagem
              v-if="params.embalagem.visible"
              v-model="params.embalagem.value"
              name="Embalagem"
              label="Embalagem"
              icon="mdi-mailbox"
              rules="required"
            />
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Pedido"
          v-if="showDataPedido"
        >
          <template #items>
            <v-col v-if="params.data_pedido_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_pedido_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_pedido_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_pedido_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.numero_pedido.visible">
              <validation-provider
                name="Nº Pedido"
                v-slot="{ errors }"
                rules="required"
              >
                <relatorio-carga-descarga-list-filtro-modal-item-input
                  label="Nº Pedido"
                  name="Nº Pedido"
                  v-model="params.numero_pedido.value"
                  :errors="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data pesagem entrada"
          v-if="showDataPesagemEntrada"
        >
          <template #items>
            <v-col v-if="params.data_pesagem_entrada_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_pesagem_entrada_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_pesagem_entrada_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_pesagem_entrada_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data pesagem saida"
          v-if="showDataPesagemSaida"
        >
          <template #items>
            <v-col v-if="params.data_pesagem_saida_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_pesagem_saida_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_pesagem_saida_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_pesagem_saida_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data Da Saída Do Patio"
          v-if="showDataSaidaPatio"
        >
          <template #items>
            <v-col v-if="params.data_saida_patio_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_saida_patio_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_saida_patio_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_saida_patio_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Data Da Conclusão"
          v-if="showDataConclusao"
        >
          <template #items>
            <v-col v-if="params.data_conclusao_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_conclusao_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_conclusao_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_conclusao_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Fornecedor"
          v-if="showFornecedor"
        >
          <template #items>
            <relatorio-carga-descarga-list-filtro-modal-item-input-fornecedor
              v-if="params.fornecedor.visible"
              v-model="params.fornecedor.value"
              name="fornecedor"
              label="Fornecedor"
              icon="mdi-account-child"
              rules="required"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input-produto
              v-if="params.produto.visible"
              v-model="params.produto.value"
              name="produto"
              label="Produto"
              icon="mdi-corn"
              rules="required"
              :multiple="true"
              :fornecedor="selectedFornecedor"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input-sub-produto
              v-if="params.sub_produto.visible"
              v-model="params.sub_produto.value"
              name="sub produto"
              label="Sub Produto"
              icon="mdi-corn"
              rules="required"
              :fornecedor="selectedFornecedor"
              :produto="selectedProduto"
              :multiple="true"
            />
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Contratos"
          v-if="showContratos"
        >
          <template #items>
            <relatorio-carga-descarga-list-filtro-modal-item-input-terminal
              v-if="params.terminal.visible"
              v-model="params.terminal.value"
              name="terminal"
              label="Terminal"
              icon="mdi-mailbox"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input-cliente
              v-if="params.cliente.visible"
              v-model="params.cliente.value"
              name="cliente"
              label="Cliente"
              icon="mdi-mailbox"
              rules="required"
              mask="XX.XXX.XXX/XXXX-##"
              :multiple="true"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input-transportadora
              v-if="params.transportadora.visible"
              v-model="params.transportadora.value"
              name="transportadora"
              label="Transportadora"
              icon="mdi-bag-carry-on"
              rules="required"
            />
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Região"
          v-if="showRegiao"
        >
          <template #items>
            <relatorio-carga-descarga-list-filtro-modal-item-input
              v-if="params.regiao.visible"
              v-model="params.regiao.value"
              name="regiao"
              label="Região"
              icon="mdi-home-city"
              rules="required"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input
              v-if="params.representante.visible"
              v-model="params.representante.value"
              name="representante"
              label="Representante (CPF)"
              icon="mdi-face-agent"
              rules="cpfValido|required"
              mask="###.###.###-##"
            />
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Veículo"
          v-if="showVeiculo"
        >
          <template #items>
            <relatorio-carga-descarga-list-filtro-modal-item-input
              v-if="params.motorista.visible"
              v-model="params.motorista.value"
              name="motorista"
              label="Motorista (CPF)"
              icon="mdi-card-account-details"
              rules="cpfValido|required"
              mask="###.###.###-##"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input
              v-if="params.placa_cavalo.visible"
              v-model="params.placa_cavalo.value"
              name="placa cavalo"
              label="Placa Cavalo"
              icon="mdi-truck"
              mask="AAA-XXXX"
              :rules="{
                min: 8,
                required: true,
              }"
            />
            <relatorio-carga-descarga-list-filtro-modal-item-input
              v-if="params.eixo.visible"
              v-model="params.eixo.value"
              name="eixo"
              label="Eixo"
              icon="mdi-truck"
              :rules="{
                min_value: 1,
                required: true,
              }"
            />
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Navio"
          v-if="showNavio"
        >
          <template #items>
            <relatorio-carga-descarga-list-filtro-modal-item-input
              v-if="params.navio.visible"
              v-model="params.navio.value"
              name="navio"
              label="Navio"
              icon="mdi-ferry"
              rules="required"
            />
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Pesagem"
          v-if="showPesagem"
        >
          <template #items>
            <v-col v-if="params.sequencia_pesagem.visible">
              <validation-provider
                name="Nº Ticket"
                v-slot="{ errors }"
                rules="required"
              >
                <relatorio-carga-descarga-list-filtro-modal-item-input
                  label="Nº Ticket"
                  name="Nº Ticket"
                  icon="mdi-barcode"
                  v-model="params.sequencia_pesagem.value"
                  :errors="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>

        <relatorio-carga-descarga-list-filtro-modal-item
          title="Tipo de Operação"
          v-if="showTipoOperacao"
        >
          <template #items>
            <v-col>
              <validation-provider
                name="tipo_operacao"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="params.tipo_operacao.value"
                  label="Tipo de Operacao"
                  prepend-icon="mdi-clipboard-flow-outline"
                  required
                  item-text="descricao"
                  item-value="id"
                  :items="tiposOperacao"
                  :error-messages="errors"
                >
                </v-autocomplete>
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Serviços"
          v-if="showServicos"
        >
          <template #items>
            <v-col>
              <validation-provider
                name="servico"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="params.servico_triado.value"
                  label="Servico"
                  prepend-icon="mdi-clipboard-flow-outline"
                  required
                  item-text="descricao"
                  item-value="descricao"
                  :items="servicos"
                  :error-messages="errors"
                >
                </v-autocomplete>
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
        <relatorio-carga-descarga-list-filtro-modal-item
          title="Agendamento"
          v-if="showAgendamento"
        >
          <template #items>
            <v-col v-if="params.public_id.visible">
              <validation-provider name="Public ID" v-slot="{ errors }">
                <relatorio-carga-descarga-list-filtro-modal-item-input
                  name="public agendamento"
                  label="Public Agendamento"
                  icon="mdi-truck"
                  v-model="params.public_id.value"
                  :errors="errors"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.codigo_externo.visible">
              <validation-provider name="Código Externo" v-slot="{ errors }">
                <relatorio-carga-descarga-list-filtro-modal-item-input
                  name="Código Externo"
                  label="Código Externo"
                  icon="mdi-barcode"
                  v-model="params.codigo_externo.value"
                  :errors="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </relatorio-carga-descarga-list-filtro-modal-item>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn plain @click="$emit('close')">Cancelar</v-btn>
        <v-btn
          class="px-8"
          x-large
          color="primary"
          @click="search"
          :disabled="areSettingsEmpty || invalid"
          ><v-icon>mdi-database-search</v-icon>
          <span>Buscar</span>
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import ContratoAPI from '@/services/tenants/contratos'

import { data } from './_data'
import { computed } from './_computed'
import { methods } from './_methods'

import ConferenciaListFiltroData from '@/components/financeiro/conferencia/conferencia-list/ConferenciaListFiltroData'
import RelatorioCargaDescargaListFiltroModalItem from '../RelatorioCargaDescargaListFiltroModalItem.vue'
import RelatorioCargaDescargaListFiltroModalItemInput from '../RelatorioCargaDescargaListFiltroModalItemInput.vue'
import RelatorioCargaDescargaListFiltroModalItemInputTerminal from '../RelatorioCargaDescargaListFiltroModalItemInputTerminal.vue'
import RelatorioCargaDescargaListFiltroModalItemInputTransportadora from '../RelatorioCargaDescargaListFiltroModalItemInputTransportadora.vue'
import RelatorioCargaDescargaListFiltroModalItemInputEmbalagem from '../RelatorioCargaDescargaListFiltroModalItemInputEmbalagem.vue'
import RelatorioCargaDescargaListFiltroModalItemInputCliente from '../RelatorioCargaDescargaListFiltroModalItemInputCliente.vue'
import RelatorioCargaDescargaListFiltroModalItemInputFornecedor from '../RelatorioCargaDescargaListFiltroModalItemInputFornecedor.vue'
import RelatorioCargaDescargaListFiltroModalItemInputProduto from '../RelatorioCargaDescargaListFiltroModalItemInputProduto.vue'
import RelatorioCargaDescargaListFiltroModalItemInputSubProduto from '../RelatorioCargaDescargaListFiltroModalItemInputSubProduto.vue'

export default {
  name: 'RelatorioCargaDescargaListFiltroModal',
  components: {
    ConferenciaListFiltroData,
    RelatorioCargaDescargaListFiltroModalItem,
    RelatorioCargaDescargaListFiltroModalItemInput,
    RelatorioCargaDescargaListFiltroModalItemInputTerminal,
    RelatorioCargaDescargaListFiltroModalItemInputTransportadora,
    RelatorioCargaDescargaListFiltroModalItemInputCliente,
    RelatorioCargaDescargaListFiltroModalItemInputEmbalagem,
    RelatorioCargaDescargaListFiltroModalItemInputFornecedor,
    RelatorioCargaDescargaListFiltroModalItemInputProduto,
    RelatorioCargaDescargaListFiltroModalItemInputSubProduto,
  },
  data,
  computed,
  methods,
  watch: {
    'params.gate.value'(newValue) {
      this.gateSelected(newValue)
    },
  },
  async created() {
    await this.getTipoOperacao()
    this.settingFilters = true

    this.getParamsFilter()

    if (this.empresaAtual.gate) {
      this.params.gate.value = this.empresaAtual.public_id
      // this.params.proprietario.value = ''
      this.gates = [this.empresaAtual]
      this.gateSelected(this.empresaAtual.public_id)
    } else {
      const { possible_gates } = await ContratoAPI.getPossiveisGates(
        this.empresaAtual.public_id
      )
      this.gates = possible_gates
      this.params.proprietario.value = this.empresaAtual.public_id
    }

    this.addParamsFilter()

    this.UPDATE_PARAMS(this.params)

    await this.showOnlySelectedOptionsAndGetItems()
    this.settingFilters = false
  },
}
</script>
